"use strict";

// Заголовочный блок с переключалкой для промо-страниц.

const $ = window.jQuery;

function MottoView(target_tabs) {
    var ui = {
        mottoSwitch: $(".js-motto-switch"),
        motto: $(".js-motto"),
    };
    if (shouldWitchMotto(location.hash)) {
        switchMotto(location.hash);
    }
    ui.mottoSwitch.on("click", onMottoSwitchClick);

    function switchMotto(hash) {
        var name = hash.substr(1);
        if (target_tabs) {
            if (name == "for-party") {
                target_tabs.activateTab("#party");
            }

            if (name == "for-address") {
                target_tabs.activateTab("#address");
            }

            if (name == "party") name = "for-party";
            if (name == "address") name = "for-address";
        }
        ui.mottoSwitch.removeClass("motto__switch--active");
        ui.mottoSwitch.filter("[href='#" + name + "']").addClass("motto__switch--active");
        ui.motto.addClass("hidden");
        ui.motto.filter("[data-for='" + name + "']").removeClass("hidden");
    }

    function shouldWitchMotto(hash) {
        var MOTTO_SWITCHES = ["customer", "address", "phone", "party", "for-address", "for-party"];
        return MOTTO_SWITCHES.indexOf(hash.substr(1)) !== -1;
    }

    function onMottoSwitchClick(e) {
        var hash = e.target.hash;
        e.preventDefault();
        history.replaceState(hash, "", hash);
        const event = new Event("switch");
        document.dispatchEvent(event);
        switchMotto(hash);
    }
}

export default MottoView;
